/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, createElem, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setHtml } from '../../dom-utils';
import { moreThanOneNode, warn } from '../../mixins';
import { destroyElem, type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Alert = /** @class */ (function () {
    function Alert() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-alert', { all: true });
        this._create(this.COMPONENTS);
    }
    Alert.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'alert');
        var AlertTitle = target.querySelector("." + PREFIX.alert + "-title");
        var AlertIcon = target.querySelector("." + PREFIX.alert + "-icon");
        return {
            get title() {
                return setHtml(AlertTitle);
            },
            set title(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                setHtml(AlertTitle, newVal);
            },
            get icon() {
                return setHtml(AlertIcon);
            },
            set icon(newVal) {
                if (!AlertIcon) {
                    warn("You need to set the \"show-icon\" attribute to \"true\" --> \"" + el + "\"");
                    return;
                }
                if (newVal && !type.isStr(newVal))
                    return;
                setHtml(AlertIcon, newVal);
            },
            events: function (_a) {
                var onClose = _a.onClose;
                var AlertClose = target.querySelector("." + PREFIX.alert + "-close");
                if (!AlertClose)
                    return;
                bind(AlertClose, 'click', function (event) { return onClose && type.isFn(onClose, event); });
            }
        };
    };
    Alert.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            if (moreThanOneNode(node))
                return;
            var _a = _this._attrs(node), icon = _a.icon, type = _a.type, title = _a.title, closable = _a.closable, banner = _a.banner, showIcon = _a.showIcon, closeText = _a.closeText;
            var placeholderNode = node.firstElementChild;
            _this._setMainTemplate(node, title);
            _this._setBanner(node, banner);
            _this._setIconType(node, type, showIcon, icon, placeholderNode);
            _this._setDescription(node, placeholderNode);
            _this._setClosable(node, closable, closeText);
            _this._handleClose(node);
            removeAttrs(node, ['title', 'icon', 'banner', 'closable', 'close-text', 'show-icon']);
        });
    };
    Alert.prototype._setMainTemplate = function (node, title) {
        var template = "\n         <div class=\"" + PREFIX.alert + "-title\">" + title + "</div>\n         <div class=\"" + PREFIX.alert + "-desc\"></div>\n        ";
        setHtml(node, template);
    };
    Alert.prototype._setBanner = function (node, banner) {
        if (!banner)
            return;
        node.classList.add(PREFIX.alert + "-with-banner");
    };
    Alert.prototype._setIconType = function (node, type, showIcon, icon, desc) {
        if (!showIcon)
            return;
        node.classList.add(PREFIX.alert + "-with-icon");
        var AlertIconWrap = createElem('span');
        AlertIconWrap.className = PREFIX.alert + "-icon";
        if (icon) {
            setHtml(AlertIconWrap, icon);
        }
        else {
            // 默认为 info 图标
            var iconType = 'information-circle';
            switch (type) {
                case 'success':
                    iconType = 'checkmark-circle';
                    break;
                case 'warning':
                    iconType = 'alert';
                    break;
                case 'error':
                    iconType = 'close-circle';
                    break;
            }
            if (desc) {
                iconType += '-outline';
            }
            var AlertIcon = "<i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-" + iconType + "\"></i>";
            setHtml(AlertIconWrap, AlertIcon);
        }
        node.appendChild(AlertIconWrap);
    };
    Alert.prototype._setDescription = function (node, placeholderNode) {
        if (!placeholderNode)
            return;
        node.classList.add(PREFIX.alert + "-with-desc");
        var AlertDesc = node.querySelector("." + PREFIX.alert + "-desc");
        AlertDesc.appendChild(placeholderNode);
    };
    Alert.prototype._setClosable = function (node, closable, closeText) {
        if (!closable)
            return;
        var AlertClose = "\n        <a class=\"" + PREFIX.alert + "-close\">\n          " + (!closeText ? " <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-close\"></i>" : closeText) + "\n        </a>";
        node.insertAdjacentHTML('beforeend', AlertClose);
    };
    Alert.prototype._handleClose = function (node) {
        var AlertIcon = node.querySelector("." + PREFIX.alert + "-close");
        if (!AlertIcon)
            return;
        bind(AlertIcon, 'click', function () { return destroyElem(node, { fadeOut: true, destroy: true }); });
    };
    Alert.prototype._attrs = function (node) {
        return {
            icon: getStrTypeAttr(node, 'icon', ''),
            type: getStrTypeAttr(node, 'type', 'info'),
            title: getStrTypeAttr(node, 'title', ''),
            closeText: getStrTypeAttr(node, 'close-text', ''),
            banner: getBooleanTypeAttr(node, 'banner'),
            closable: getBooleanTypeAttr(node, 'closable'),
            showIcon: getBooleanTypeAttr(node, 'show-icon')
        };
    };
    return Alert;
}());
export default Alert;
